import { lazy } from "react";
import { Route } from "react-router-dom";

export enum DashboardRoutes {
    HOME = "/",
    ADD = "/new-project",
    DASHBOARD = "/dashboard",
    PROPERTY = "/property/:id",
    PROJECT = "/project/:id",
    EDIT = "/edit-project/:id",
    BROKER_DETAIL = "/broker-detail/:id",
    COMMISSION_CONFIG = "/commission-config",
    BROKER_ANALYTICS = "/broker-analytics",
    INVESTOR_DASHBOARD = "/investor-dashboard",
    HEALTH_DASHBOARD = "/health-dashboard",
    LEGAL_CONTRACTS = "/legal-contracts",
    ADMIN_MARKETPLACE = "/admin-marketplace",
    AI_CONFIG = "/ai-config",
    DEVELOPER_DASHBOARD = "/developer-dashboard",
}

const DashboardPage = lazy(() => import("./DashboardPage"));
const CreateProjectPage = lazy(() => import("./CreateProject"));
const HomePage = lazy(() => import("./HomePage"));
const CreatePropertyPage = lazy(() => import("./CreatePropertyPage"));
const ProjectPage = lazy(() => import("./ProjectPage"));
const EditProjectPage = lazy(() => import("./EditProject"));
const BrokerDetailPage = lazy(() => import("./BrokerDetailPage"));
const CommissionConfigPage = lazy(() => import("./CommissionConfigPage"));
const BrokerAnalyticsPage = lazy(() => import("../admin/page/BrokerAnalyticsPage/BrokerAnalyticsPage"));
const InvestorDashboardPage = lazy(() => import("../admin/page/InvestorDashboard/InvestorDashboard"));
const HealthDashboardPage = lazy(() => import("./HealthDashboardPage"));
const LegalContractsPage = lazy(() => import("./LegalContractsPage"));
const AdminMarketplacePage = lazy(() => import("../admin/page/AdminMarketplace/AdminMarketplace"));
const AIConfigPage = lazy(() => import("../admin/page/AIConfigPage/AIConfigPage"));
const DeveloperDashboardPage = lazy(() => import("../admin/page/DeveloperDashboard/DeveloperDashboard"));

export const DashboardRouter = (
    <>
        <Route path={DashboardRoutes.HOME} element={<HomePage />} />
        <Route path={DashboardRoutes.DASHBOARD} element={<DashboardPage />} />
        <Route path={DashboardRoutes.ADD} element={<CreateProjectPage />} />
        <Route path={DashboardRoutes.PROPERTY} element={<CreatePropertyPage />} />
        <Route path={DashboardRoutes.PROJECT} element={<ProjectPage />} />
        <Route path={DashboardRoutes.EDIT} element={<EditProjectPage />} />
        <Route path={DashboardRoutes.BROKER_DETAIL} element={<BrokerDetailPage />} />
        <Route path={DashboardRoutes.COMMISSION_CONFIG} element={<CommissionConfigPage />} />
        <Route path={DashboardRoutes.BROKER_ANALYTICS} element={<BrokerAnalyticsPage />} />
        <Route path={DashboardRoutes.INVESTOR_DASHBOARD} element={<InvestorDashboardPage />} />
        <Route path={DashboardRoutes.HEALTH_DASHBOARD} element={<HealthDashboardPage />} />
        <Route path={DashboardRoutes.LEGAL_CONTRACTS} element={<LegalContractsPage />} />
        <Route path={DashboardRoutes.ADMIN_MARKETPLACE} element={<AdminMarketplacePage />} />
        <Route path={DashboardRoutes.AI_CONFIG} element={<AIConfigPage />} />
        <Route path={DashboardRoutes.DEVELOPER_DASHBOARD} element={<DeveloperDashboardPage />} />
    </>
);
